RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    function countPages(config) {
        let pages = 1;
        _.each(config, function (region) {
            let page;
            if (_.isArray(region)) {
                page = countPages(region);
            } else {
                page = region.page + 1;
            }

            pages = Math.max(page || 1, pages);
        });

        return pages;
    }

    function filterConfig(config, page) {
        const result = [];
        _.each(config, function (region) {
            if (_.isArray(region)) {
                const subresult = filterConfig(region, page);
                if (subresult.length) {
                    result.push(subresult);
                }
            } else if (region.page === page) {
                result.push(region);
            }
        });

        return result;
    }

    /*
     * To split results across multiple pdf pages, the PDF layout creates
     * a copy of the layout for each page surrounds it with page-break styling
     */
    views.ExportLayout = RivalIQ.views.CollectionView.mixin({
        childView: App.views.Layout,
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        childViewOptions: function (child, page) {
            const me = this;

            return {
                className: 'export-page',
                config: (me.pageCount > 1 ? filterConfig(me.config, page) : me.config),
                collection: me.widgets,
                dashboardModel: me.dashboardModel
            };
        },
        initialize: function () {
            const me = this;
            me.widgets = me.collection;
            me.pageCount = countPages(me.config);
            me.collection = new Backbone.Collection(_.map(_.range(0, me.pageCount), function () {
                return new Backbone.Model();
            }));
        }
    });

    views.PdfWidgets = App.views.Widgets.extend({
        _createBuffer: function () {
            const me = this;
            const elBuffer = document.createDocumentFragment();
            _.each(me._bufferedChildren, function (b) {
                const wrapper = document.createElement('div');
                wrapper.className = 'export-page';
                wrapper.appendChild(b.el);

                elBuffer.appendChild(wrapper);
            });

            return elBuffer;
        }
    });

    views.PdfCurationWidgets = views.ExportLayout.extend({
        initialize: function () {
            const me = this;
            me.widgets = me.collection;
            me.collection = new Backbone.Collection([{}]);
        },
        childView: views.PdfWidgets,
        childViewOptions: function () {
            const me = this;
            return {
                collection: me.widgets,
                dashboardModel: me.dashboardModel
            };
        }
    });

    views.ExportWidgets = RivalIQ.views.LayoutView.mixin({
        template: '#dashboardWidgetsTemplate',
        childView: views.Widgets,
        regions: {
            header: '.x-header',
            widgets: '.x-widgets-region'
        },
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        getTitleView: function () {
            const me = this;
            if (me.dashboardModel.isExportingPDF()) {
                return views.TitlePage;
            }

            return views.TitleBar;
        },
        onBeforeRenderLoaded: function () {
            const me = this;

            let View;

            if (me.hideExportTitleBar !== true) {
                View = me.getTitleView();
                me.header.show(new View({
                    dashboardModel: me.dashboardModel
                }));
            }

            View = me.childView;
            me.widgets.show(new View({
                collection: me.dashboardModel.getWidgets(),
                dashboardModel: me.dashboardModel
            }));
        }
    });
});
